<template>
  <div :class="cls" v-if="show">
      <div class="__toast-icon" v-show="type !== 'none'">
        <img src="@/assets/cms/toastSuccess.png" v-if="type == 'success'">
        <img src="@/assets/cms/toastFail.png" v-if="type == 'fail'">
      </div>
      <div class="__toast-text gm-fs-16">{{text}}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  computed: {
    cls: function() {
      return this.type === 'none' ? '__toast __onlyText' : '__toast'
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/style/func.scss';
@import '@/style/define.scss';
.__toast {
  position: fixed;
  left: 50%;
  top: 50%;
  min-width: px2rem(140px);
  max-width: px2rem(240px);
  height: px2rem(126px);
  background: color(000, fl, 0.6);
  border-radius: px2rem(4px);
  color: color(ff, white);
  transform: translate(-50%, -50%);
  z-index: 100;
  .__toast-icon {
    height: px2rem(45px);
    text-align: center;
    margin-top: px2rem(25px);
    img {
      height: 100%;
      width: auto
    }
  }
  .__toast-text {
    margin-top: px2rem(11px);
    text-align: center
  }
}
.__onlyText {
  height: auto;

  .__toast-text {
    margin: 0;
    padding: px2rem(12px) px2rem(20px);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Toast/Toast.vue